import React from 'react'
import { Subheading } from '../HeadingModule/Subheading'
import '../../styles/ArticleCarouselModule/ArticleCarouselSubheading.scss'

export interface ArticleCarouselSubheadingProps {
  subheading: string
  fallback: string
}

export const ArticleCarouselSubheading = ({ subheading, fallback }: ArticleCarouselSubheadingProps) => {
  return <Subheading text={subheading || fallback} className="article-carousel-subheading" />
}
